var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', [_c('main-recruitment-tit', _vm._b({}, 'main-recruitment-tit', {
    title: _vm.title,
    route: _vm.route
  }, false)), _c('v-row', [_vm._l(_vm.items, function (item) {
    return [_c('v-col', {
      key: item._id,
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "3"
      }
    }, [_c('main-recruitment-card', {
      attrs: {
        "recruitment": item
      }
    })], 1)];
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }